// extracted by mini-css-extract-plugin
export default {"root":"SortableSectionWrapper__root--W3AY4","toggle":"SortableSectionWrapper__toggle--GASJU"};